import { Box, type BoxProps as ChakraBoxProps } from "@chakra-ui/react";

export type ComponentWrapperProps = ChakraBoxProps;

export const ComponentWrapper = ({ children, bg, ...props }: ComponentWrapperProps) => {
	return (<Box w={"100%"} bg={bg} zIndex={1} position={"relative"}><Box maxW={"120rem"} mx="auto" {...props}>{children}</Box></Box>)
}